'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface VideoTestimonialProps {
  name: string;
  role: string;
  thumbnail: string;
  alt: string;
  duration: string;
  title: string;
}

export default function VideoTestimonial({
  name,
  role,
  thumbnail,
  alt,
  duration,
  title
}: VideoTestimonialProps) {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <div className="bg-white rounded-xl shadow-subtle hover:shadow-elevated transition-all duration-300 overflow-hidden border border-border group">
      <div className="relative aspect-video bg-gray-900 overflow-hidden">
        <AppImage
          src={thumbnail}
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        
        {!isPlaying && (
          <button
            onClick={handlePlayClick}
            className="absolute inset-0 flex items-center justify-center group/play"
            aria-label="Play video testimonial"
          >
            <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover/play:bg-accent group-hover/play:scale-110 transition-all duration-300 shadow-elevated">
              <Icon name="PlayIcon" variant="solid" size={24} className="text-primary ml-1" />
            </div>
          </button>
        )}

        <div className="absolute bottom-4 right-4 bg-black/70 text-white text-xs px-2 py-1 rounded">
          {duration}
        </div>
      </div>

      <div className="p-5">
        <h3 className="font-display text-lg font-semibold text-text-primary mb-2">
          {title}
        </h3>
        <p className="text-sm text-text-secondary">
          {name} • {role}
        </p>
      </div>
    </div>
  );
}